import { createAsyncThunk } from '@reduxjs/toolkit';
import createNotification from '../../../../utils/createNotification';

export const GetOpportunity = createAsyncThunk(
    'marketplace/getOpportunity',
    async (opportunityId: number, dispatch: any) => {
        const axios = dispatch.getState().core.axios;

        try {
            const response = await axios.get(
                `/api/Marketplace/MarketplaceOpportunities/${opportunityId}`
            );

            if (response.status !== 200) {
                createNotification(
                    'Could not fetch opportunity at the moment.',
                    'error'
                );
                throw new Error('Failed to fetch opportunity');
            }

            return {
                opportunity: response.data,
            };
        } catch (error) {
            createNotification(
                'An error occurred while fetching opportunity.',
                'error'
            );
            throw error;
        }
    }
);
